import { extend } from 'vee-validate'

const vee_validate_config = {
 classes: {
  invalid: 'inputError'
 },
};

export default vee_validate_config;
